<template>
  <div class="life">
    <picture>
      <source
        media="(max-width: 767px)"
        srcset="~@/assets/images/life-mobile.png 767w"
      />
      <img class="life-banner" src="~@/assets/images/life.jpg" />
    </picture>
    <Title />
    <LifePage1 v-if="page === '1'" />
    <LifePage2 v-if="page === '2'" />
    <LifePage3 v-if="page === '3'" />
    <LifePage4 v-if="page === '4'" />
  </div>
</template>

<script>
import Title from 'Pages/MainModule/Title.vue';
import LifePage1 from 'Pages/LifeModule/LifePage1.vue';
import LifePage2 from 'Pages/LifeModule/LifePage2.vue';
import LifePage3 from 'Pages/LifeModule/LifePage3.vue';
import LifePage4 from 'Pages/LifeModule/LifePage4.vue';
export default {
  name: 'Life',
  data() {
    return {
      page: this.$route.query.page,
    };
  },
  components: {
    Title,
    LifePage1,
    LifePage2,
    LifePage3,
    LifePage4,
  },
  watch: {
    $route() {
      this.page = this.$route.query.page;
    },
  },
};
</script>

<style scoped>
.life {
  text-align: left;
}
.life-banner {
  width: 100%;
  vertical-align: top;
}
.life > div {
  margin: 20px 20% 0 20%;
}
@media (max-width: 767px) {
  .life > div {
    margin: 0 20px;
  }
  .life-banner {
    margin-top: 10px;
  }
}
@media (min-width: 768px) and (max-width: 1024px) {
  .life > div {
    margin: 20px 10% 0 10%;
  }
}
</style>
